import { render, staticRenderFns } from "./wuliu.vue?vue&type=template&id=a94480dc&scoped=true"
import script from "./wuliu.vue?vue&type=script&lang=js"
export * from "./wuliu.vue?vue&type=script&lang=js"
import style0 from "./wuliu.vue?vue&type=style&index=0&id=a94480dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94480dc",
  null
  
)

export default component.exports